/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import { call, put, takeEvery, select } from "redux-saga/effects";
import { getRequest, postRequest, putRequest, exportRequest } from "../../helpers/Api";
import { types } from "../reducers/device";
import { userNotAuthorizedHandler } from "./authentication";

function* storeDevice({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  try {
    const res = yield call(payload.id ? putRequest : postRequest, {
      url: payload.id ? `/device/${payload.id}` : "/device",
      jsonContentType: true,
      authorized: true,
      body: JSON.stringify(payload.device),
    });

    yield put({ type: types.SET_LOADING, payload: { loading: false } });
    if (res.status === 409) {
      const errorMessage =
        res.response && res.response.message
          ? res.response.message
          : res.message === "Conflict"
          ? "Device is used already"
          : res.message;
      payload.onFailure(errorMessage, {
        errors: [
          {
            key: res.response && res.response.field ? res.response.field : "description",
            error: errorMessage,
          },
        ],
      });
    } else if (res.status === 401) {
      yield call(userNotAuthorizedHandler);
      payload.onSuccess(null);
      return;
    } else if (res.status === 200) {
      payload.onSuccess(res);
      yield put({
        type: types.FETCH_DEVICE_REQUEST,
        payload: { page: 1, perPage: 20, onFailure: payload.onFailure },
      });
    } else {
      payload.onFailure(res.message);
    }
  } catch (err) {
    yield put({ type: types.SET_LOADING, payload: { loading: false } });
    // @ts-ignore
    payload.onFailure(err.message || "Internal server error");
  }
}
/**
 * Fetch devices when filters are changed
 */
function* fetchDeviceRequest({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  const {
    page: prevPage,
    perPage: prevPerPage,
    qs: prevQs,
  } = yield select((state) => state.devices);
  const params = new URLSearchParams();
  params.append("perPage", prevPerPage || "20");
  params.append("page", prevPage || "0");
  params.append("qs", prevQs || "");

  const response = yield call(getRequest, {
    url: `/device?${params.toString()}`,
    authorized: true,
  });

  if (response.status === 401) {
    yield put({ type: types.SET_LOADING, payload: { loading: false } });
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (response.status === 200) {
    const devices = response.result.map((comp) => {
      if (comp.status) {
        comp.status = "1";
      } else {
        comp.status = "0";
      }
      return comp;
    });
    yield put({ type: types.ADD_DEVICES, payload: { devices } });
    yield put({
      type: types.SET_DEVICE_TOTAL_ITEMS,
      payload: {
        totalItems: response.totalItems,
      },
    });
    yield put({ type: types.SET_LOADING, payload: { loading: false } });
  } else {
    yield put({ type: types.SET_LOADING, payload: { loading: false } });
    payload.onFailure(response.message || "Internal server error");
  }
}

function* exportDeviceRequest({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  const {
    page: prevPage,
    perPage: prevPerPage,
    qs: prevQs,
  } = yield select((state) => state.punches);
  const params = new URLSearchParams();
  params.append("perPage", prevPerPage || "20");
  params.append("page", prevPage || "0");
  params.append("qs", prevQs || "");

  const response = yield call(exportRequest, {
    url: `/export/device?${params.toString()}`,
    authorized: true,
  });

  if (!response.status === 200) {
    payload.onFailure(response.message || "Internal server error");
  }
  yield put({ type: types.SET_LOADING, payload: { loading: false } });
}

export default function* sagas() {
  yield takeEvery(types.ADD_DEVICE, storeDevice);
  yield takeEvery(types.UPDATE_DEVICE, storeDevice);
  yield takeEvery(types.FETCH_DEVICE_REQUEST, fetchDeviceRequest);
  yield takeEvery(types.EXPORT_DEVICE_REQUEST, exportDeviceRequest);
}
